export default __webpack_public_path__ + "static/media/card_bg_yizhixiang.afe4ce54.png";